import axios from "axios";
import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Moment from "react-moment";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { NetworkAxios } from "../../API";
import Comment from "../../components/discussionBoard/comment";
import PostComment from "../../components/discussionBoard/postComment";
import ShowMore from "../../shared/commonComponents/ShowMore";
import { Checkbox } from "../../shared/inputs";
import Loader from "../../shared/Loader";


let cancelToken = axios.CancelToken.source();
const Forums = () => {
  const location = useLocation();
  console.log("location ::: ", location);
  useEffect(() => {
    if (location.state) {
      var elem = document.getElementById(location.state.threadId);
      if (elem) {
        elem.scrollIntoView();
        // handleForumCollapse(forumList.filter(x=>x.id === location.state.threadId)[0])
      }
    }
  });

  //const dispatch = useDispatch();
  // const forumList = useSelector((state) => state.forum.forumsData);
  const loggedInUser = useSelector((state) => state.auth.loggedInUser);
  const [loading, setLoading] = useState(true);
  const [selectedForum, setSelectedForum] = useState(null);
  const [selectedForumId, setSelectedForumId] = useState(0);
  const [forumList, setForumList] = useState([]);
  const handleForumCollapse = (item) => {
    item.isCollapsed = !item.isCollapsed;
    setSelectedForum({});
    setSelectedForumId(item.id);
    getForumComments(item.id);

  };

  const getForumList = () => {

    // NetworkAxios.get(`Forum/getforums/${loggedInUser.offeringId}/${loggedInUser.missionId}/${loggedInUser.teamId}`)
    NetworkAxios.get(
      `Forum/getforums/${loggedInUser.offeringId}/${loggedInUser.missionId}/${loggedInUser.teamId}`
    )
      .then((res) => {
        setLoading(false);
        var temp = res.data.map((item) => {
          return { ...item, isCollapsed: false };
        });
        setForumList(temp);
        //dispatch(ForumSlice.actions.setForumsData(temp));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getForumList();
  }, []);

  const setLikeItem = (islike, item) => {
    var temp = [...selectedForum.comments];
    if (
      item.parentCommentId == null ||
      item.parentCommentId == undefined ||
      item.parentCommentId == 0
    ) {
      var index = temp
        .map(function (e) {
          return e.id;
        })
        .indexOf(item.id);
      temp[index]["isLiked"] = islike;
      if (islike) {
        temp[index]["likes"] = temp[index]["likes"] + 1;
      } else {
        temp[index]["likes"] = temp[index]["likes"] - 1;
      }
    } else {
      var parentIndex = temp
        .map(function (e) {
          return e.id;
        })
        .indexOf(item.parentCommentId);
      var index = temp[parentIndex]["replies"]
        .map(function (e) {
          return e.id;
        })
        .indexOf(item.id);
      temp[parentIndex]["replies"][index]["isLiked"] = islike;
      if (islike) {
        temp[parentIndex]["replies"]["likes"] =
          temp[parentIndex]["replies"]["likes"] + 1;
      } else {
        temp[parentIndex]["replies"]["likes"] =
          temp[parentIndex]["replies"]["likes"] - 1;
      }
    }
    var tempObj = { ...selectedForum };
    tempObj.comments = [...temp];
    setSelectedForum({ ...tempObj });
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [activeShowMore, setActiveShowMore] = useState(false);
  const [pageSize, setPageSize] = useState(10000);
  const [onClickShowMore, setOnClickShowMore] = useState(false);

  useEffect(() => {
    if (onClickShowMore) {
      getForumComments(selectedForumId);
    }
  }, [onClickShowMore]);

  const getForumComments = (id) => {
    cancelToken.cancel();
    cancelToken = axios.CancelToken.source();
    var tempPageNumber = 1;
    if (onClickShowMore) {
      tempPageNumber = pageNumber;
    }

    NetworkAxios.get(
      `Forum/getforumbyid/${id || selectedForumId}/${loggedInUser.offeringUserId
      }/${tempPageNumber}/${pageSize}`, { cancelToken: cancelToken.token }
    )
      .then((res) => {
        // dispatch(ForumSlice.actions.setSelectedForum(res.data));
        //setSelectedForum({});        
        if (onClickShowMore && selectedForum?.forumTitle === res.data.forumTitle) {
          var tempSelectedForumComments = JSON.parse(JSON.stringify(selectedForum.comments));
          //tempSelectedForumComments.push(res.data.comments);  
          var totalComments = tempSelectedForumComments.concat(res.data.comments);
          setSelectedForum({ ...selectedForum, comments: totalComments });
          setOnClickShowMore(false);
          if (totalComments.length == pageSize * pageNumber) {
            setPageNumber(pageNumber + 1);
            setActiveShowMore(true);
          } else {
            setActiveShowMore(false);
          }
        } else {
          setOnClickShowMore(false);
          setSelectedForum({});
          setSelectedForum(res.data);
          if (res.data.comments.length == pageSize) {
            setPageNumber(2);
            setActiveShowMore(true);
          } else {
            setActiveShowMore(false);
          }
        }

      })
      .catch((err) => {
        console.log(err);
      });
  };

  const reloadData = () => {
    //getForumList();
    getForumComments();
    setPageNumber(1);
  };

  const [isStartNewThread, setIsStartNewThread] = useState(false);
  const [newThreadTitle, setNewThreadTitle] = useState("");
  const [newThreadDesc, setNewThreadDesc] = useState("");
  const [offeringLevelThread, setOfferingLevelThread] = useState(false);
  const [missionLevelThread, setMissionLevelThread] = useState(true);
  const [threadErrorMsg, setThreadErrorMsg] = useState(false);

  useEffect(() => {
    setNewThreadTitle("");
    setNewThreadDesc("");
    setMissionLevelThread(true);
    setOfferingLevelThread(false);
  }, [isStartNewThread]);

  const startNewThread = () => {
    if (newThreadTitle === "") {
      setThreadErrorMsg("Please enter title.");
      return;
    }

    var data = {
      offeringId: 0,
      missionId: 0,
      teamId: 0,
      forumTitle: newThreadTitle,
      description: newThreadDesc,
      initiatedBy: loggedInUser.userId,
      isSolveTabForum: false,
      forumCreatedBy: loggedInUser.firstName + " " + loggedInUser.lastName,
    };
    if (offeringLevelThread) data.offeringId = loggedInUser.offeringId;
    if (missionLevelThread) data.missionId = loggedInUser.missionId;

    NetworkAxios.post(`Forum/createforum`, data)
      .then((res) => {
        setNewThreadTitle("");
        setNewThreadDesc("");
        setOfferingLevelThread(true);
        setMissionLevelThread(false);
        setIsStartNewThread(false);
        getForumList();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const newThreadTitleHandler = (event) => {
    setThreadErrorMsg("");
    setNewThreadTitle(event.target.value);
  };

  const newThreadDescHandler = (event) => {
    setNewThreadDesc(event.target.value);
  };

  return (
    <>
      <Row style={{ margin: 0 }}>
        <Col className="thread-heading-background">
          <span className="thread-heading-text">All Discussion Threads</span>
          {loggedInUser.roleId === 5 && (
            <button
              className="startnewthread cdx-btn"
              onClick={() => {
                setIsStartNewThread(!isStartNewThread);
              }}
            >
              Start New Discussion
              <div
                className={
                  isStartNewThread
                    ? "discussion-up "
                    : "discussion-up discussion-rotate"
                }
              ></div>
            </button>
          )}
        </Col>
      </Row>
      {isStartNewThread && (
        <Row style={{ margin: 0 }}>
          <Col className="">
            <div className="newThreadWrapper">
              <label className="threadLabel">Title</label>
              <input
                type="text"
                className="threadTitle"
                maxLength="100"
                onChange={newThreadTitleHandler}
                value={newThreadTitle}
              />
              {threadErrorMsg !== "" && (
                <div>
                  <span className="threadErrorMsg">{threadErrorMsg}</span>
                </div>
              )}
              <label className="threadLabel">Description</label>
              <textarea
                onChange={newThreadDescHandler}
                value={newThreadDesc}
                className="threadDesc"
                id="desc"
                name="desc"
                rows="4"
                cols="50"
                maxLength="200"
              ></textarea>
              <div className="newthreadcheckboxwrapper">
                <Checkbox
                  className="profile-checkbox-input"
                  label="All Missions"
                  checked={offeringLevelThread}
                  onChange={() => {
                    setMissionLevelThread(!missionLevelThread);
                    setOfferingLevelThread(!offeringLevelThread);
                  }}
                />
                <Checkbox
                  className="profile-checkbox-input"
                  label={loggedInUser.missionName}
                  checked={missionLevelThread}
                  onChange={() => {
                    setOfferingLevelThread(!offeringLevelThread);
                    setMissionLevelThread(!missionLevelThread);
                  }}
                />
              </div>
              <div className="newthreadbuttonwrapper">
                <button
                  className="startnewthread cdx-btn"
                  onClick={() => {
                    startNewThread();
                  }}
                >
                  Create
                </button>
                <button
                  className="startnewthread cdx-btn"
                  onClick={() => {
                    setIsStartNewThread(false);
                    setMissionLevelThread(true);
                    setOfferingLevelThread(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Col>
        </Row>
      )}
      {loading ?
        <Loader loading={true} />
        : <Row
          style={{ margin: 0 }}
          className="scroll-content forum-scroll-content"
        >
          <Col>
            <Accordion defaultActiveKey="0" flush>
              {forumList &&
                forumList.map((item) => {
                  return (
                    <Accordion.Item
                      key={`acc-${item.id}`}
                      className="forum-accordion-item"
                      id={item.id}
                      eventKey={item.id}
                    >
                      <Accordion.Button
                        as="div"
                        className="forum-accordion-button"
                        onClick={() => {
                          handleForumCollapse(item);
                        }}
                      >
                        <Row className="w-100">
                          <Col sm={7} className="forum-item-box-1">
                            <Row className="forum-item-title">
                              <span>{item.forumTitle}</span>
                            </Row>
                            <Row className="forum-item-time">
                              <span>
                                Created by {item.forumCreatedBy} on{" "}
                                <Moment
                                  // add={{ hours: 24 }}
                                  format="MMM D, YYYY [at] h:mm A"
                                  local={true}
                                >
                                  {item.createdOn + "Z"}
                                </Moment>
                              </span>
                            </Row>
                          </Col>
                          <Col
                            sm={4}
                            className="forum-item-box-2 forum-accourdion-info"
                          >
                            <span style={{ paddingRight: "5px" }}>
                              {item.likeCount} Like(s)
                            </span>{" "}
                            <span>{item.commentCount} Comments</span>
                          </Col>
                          <Col sm={1} className="forum-item-box-3 ">
                            {/* {!item.isCollapsed && <div className="forum-down"></div>} */}
                            <div className="forum-up"></div>
                          </Col>
                        </Row>
                      </Accordion.Button>
                      <Accordion.Body className="forum-comment-body">
                        <div className="form-desc">
                          {selectedForum && (
                            <span>{selectedForum.description}</span>
                          )}
                        </div>
                        <PostComment
                          thread={selectedForum && selectedForum.forumTitle}
                          showAssignment={false}
                          forumId={selectedForumId}
                          reloadComments={reloadData}
                        ></PostComment>
                        {selectedForum &&
                          selectedForum.comments &&
                          selectedForum.comments
                            .sort((a, b) =>
                              a.commentedOn < b.commentedOn ? 1 : -1
                            )
                            .map((item, index) => {
                              return (
                                <Comment key={`qssdcf${index}`}
                                  thread={
                                    selectedForum && selectedForum.forumTitle
                                  }
                                  forumId={selectedForumId}
                                  setLikeItem={setLikeItem}
                                  reloadComments={reloadData}
                                  comment={item}
                                />
                              );
                            })}
                        {selectedForum?.comments?.length >= pageSize && activeShowMore && (
                          <ShowMore onClick={() => setOnClickShowMore(true)} />
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
            </Accordion>
          </Col>
        </Row>
      }
    </>
  );
};

export default Forums;
